var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F3FFE0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_13881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.697 9.27341C19.0613 9.1667 17.4233 9.44171 15.9122 10.0767C14.4011 10.7117 13.0584 11.6894 11.99 12.9324C10.9156 14.1767 10.1432 15.6524 9.73287 17.2443C9.32256 18.8362 9.28545 20.5014 9.62445 22.11C9.96345 23.7186 10.6694 25.2272 11.6872 26.5181C12.7051 27.8091 14.0073 28.8475 15.4925 29.5524C16.9732 30.2531 18.5967 30.5996 20.2344 30.5644C21.8722 30.5291 23.4793 30.1132 24.9285 29.3494C24.9747 29.3257 25.0265 29.3146 25.0785 29.3174C25.1304 29.3203 25.1807 29.337 25.224 29.3659C26.6002 30.2876 28.2237 30.7701 29.88 30.7499C29.919 30.7499 29.9576 30.7422 29.9937 30.7272C30.0297 30.7123 30.0624 30.6904 30.09 30.6627C30.1175 30.6351 30.1393 30.6023 30.1542 30.5662C30.169 30.5301 30.1766 30.4914 30.1765 30.4524V26.8354C30.1774 26.7645 30.1531 26.6956 30.108 26.6409C30.0631 26.5863 30.0001 26.5497 29.9305 26.5379C29.5896 26.4838 29.2568 26.388 28.9395 26.2524C28.9002 26.235 28.8652 26.2091 28.837 26.1767C28.8087 26.1444 28.7879 26.1062 28.776 26.0649C28.7641 26.0235 28.761 25.9801 28.767 25.9374C28.7732 25.8946 28.7885 25.8537 28.812 25.8174C30.376 23.4668 30.9459 20.5927 30.3971 17.8232C29.8484 15.0537 28.2256 12.614 25.8835 11.0374C24.3371 9.99919 22.5436 9.38838 20.685 9.26691L20.697 9.27341ZM13.5885 19.9099C13.5854 18.6352 13.9598 17.3881 14.6646 16.326C15.3693 15.2638 16.3728 14.434 17.5485 13.9414C18.7219 13.4524 20.0145 13.324 21.2612 13.5726C22.5079 13.8213 23.6524 14.4356 24.5485 15.3374C25.2209 16.0135 25.7356 16.8299 26.0558 17.7281C26.376 18.6263 26.4937 19.5842 26.4006 20.5332C26.3075 21.4822 26.0058 22.3989 25.5172 23.2178C25.0285 24.0366 24.365 24.7374 23.574 25.2699C22.3397 26.098 20.8558 26.4709 19.3767 26.3246C17.8976 26.1782 16.5155 25.5218 15.4675 24.4679C14.2623 23.2565 13.5852 21.6177 13.584 19.9089L13.5885 19.9099Z",
    stroke: "#5AFC60",
    strokeOpacity: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_13881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContest);
export default __webpack_public_path__ + "static/media/contest.a406269dc6b95adfda11efe61be5888e.svg";
export { ForwardRef as ReactComponent };